import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ChurnTier, UserChurnScoreDto } from '../../../models/churn-prediction/dto/churn-prediction.dto';

export const GET_CHURN_USERS_QUERY_KEY = (
  organizationId: string,
  tier?: ChurnTier,
  limit?: number,
  offset?: number,
  sortDir?: string,
) => ['churn-users', organizationId, tier, limit, offset, sortDir];

interface ChurnUsersResponse {
  users: UserChurnScoreDto[];
  total: number;
}

export function useGetChurnUsers(
  organizationId?: string,
  tier?: ChurnTier,
  limit = 10,
  offset = 0,
  sortDir = 'DESC',
) {
  const apiClient = useApiClient();

  return useQuery<ChurnUsersResponse>({
    enabled: Boolean(organizationId),
    queryKey: GET_CHURN_USERS_QUERY_KEY(organizationId!, tier, limit, offset, sortDir),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    queryFn: async (): Promise<ChurnUsersResponse> => {
      const params = new URLSearchParams();
      if (tier) params.set('tier', tier);
      params.set('limit', String(limit));
      params.set('offset', String(offset));
      params.set('sortDir', sortDir);

      const response = await apiClient.fetchApi<ChurnUsersResponse, {}>({
        method: 'GET',
        endpoint: `churn-prediction/admin/${organizationId}/users?${params.toString()}`,
      });
      return response;
    },
  });
}
